import { PlainTooltip } from "@similarweb/ui-components";
import { StyledFullWidthWrapper } from "app/pages/sales-intelligence/pages/home/styles";
import type { ComponentType } from "react";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";

type TProps = {
    tooltipText: string;
};

const withTooltipCell =
    (props: TProps) =>
    <T extends ITableCellProps>(CellComponent: ComponentType<T>) =>
    function(componentProps: T) {
        const { tooltipText } = props;
        return (
            <PlainTooltip
                tooltipContent={tooltipText}
                placement="top"
            >
                <StyledFullWidthWrapper>
                    <CellComponent {...componentProps} />
                </StyledFullWidthWrapper>
            </PlainTooltip>
        );
    };

export default withTooltipCell;
